import * as React from "react";
import {Nav, NavItem, Row} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {LinkContainer} from "react-router-bootstrap";
import {ConfigurationSets} from "./model";
import {ApolloApi} from "../api/ApolloApi";
import {Spinner} from "../common/ui/spinner/Spinner";
import {oidcProviderInfo} from "../oidc/startOidcProvider";
import {AxiosError} from "axios";
import {ErrorDisplay} from "../common/ui/errordisplay/ErrorDisplay";
import {Redirect} from "react-router-dom";

interface SettingsNavigationState {
  configurationDescription: ConfigurationSets;
  loading: boolean;
  active: string;
  isStudioManager: boolean;
  error: AxiosError;
}

export class SettingsNavigation extends React.Component<{}, SettingsNavigationState> {
  constructor(props) {
    super(props);
    this.state = {
      configurationDescription: null,
      loading: true,
      active: "",
      isStudioManager: false,
      error: null,
    };
  }

  componentDidMount() {
    ApolloApi.getStudioSettingsDescription()
        .then((configurationSets) => {
          configurationSets.configurationSets = configurationSets.configurationSets.filter(
              (set) => {
                //Not using Dynamic config page for Map Preview
                return set.name !== "Map Preview";
              });

          this.setState({
            configurationDescription: configurationSets,
            loading: false,
            active: this.getActiveTab(document.documentURI),
          });
        })
        .catch((error) => {
          this.setState({error});
        });
    if (!oidcProviderInfo?.enabled) {
      ApolloApi.getCurrentUser()
          .then((aCurrentUser) => {
            ApolloApi.getUser(aCurrentUser)
                .then((aUserDetail) => {
                  this.setState({isStudioManager: aUserDetail.roles.includes("STUDIOMANAGER")});
                })
                .catch((error) => {
                  this.setState({error});
                })
          })
          .catch((error) => {
            this.setState({error});
          });
    }
  }

  render() {
    const {error} = this.state;

    if (error) {
      if (error?.response.status === 401) {
        return <Redirect to="/login"/>;
      }
      return <ErrorDisplay error={error}/>;
    }

    if (this.state.loading) {
      return this.renderLoading();
    }

    return (
        <Nav stacked={true} onClick={this.setActive}>
          <LinkContainer to="/settings/dataroots">
            <NavItem>
              <FormattedMessage id="studio.settings-navigation.link-data-roots"
                                defaultMessage="Data roots"/>
            </NavItem>
          </LinkContainer>
          <LinkContainer to="/settings/mappreview">
            <NavItem>
              <FormattedMessage id="studio.settings-navigation.link-map-preview"
                                defaultMessage="Map preview"/>
            </NavItem>
          </LinkContainer>
          <LinkContainer to="/settings/logs">
            <NavItem>
              <FormattedMessage id="studio.settings-navigation.link-logs" defaultMessage="Logs"/>
            </NavItem>
          </LinkContainer>
          <LinkContainer to="/settings/status">
            <NavItem>
              <FormattedMessage id="studio.settings-navigation.link-status" defaultMessage="Status"/>
            </NavItem>
          </LinkContainer>
          {this.renderUserManagementElements()}
          {this.renderConfigurationElements()}

        </Nav>
    );
  }

  private renderUserManagementElements = () => {
    const configurationElements: JSX.Element[] = [];
    if (!this.state.isStudioManager) {
      if (!oidcProviderInfo?.enabled) {
        configurationElements.push(
            <LinkContainer to="/settings/users">
              <NavItem>
                <FormattedMessage id="studio.settings-navigation.link-users" defaultMessage="Users"/>
              </NavItem>
            </LinkContainer>);
      }
      configurationElements.push(
          <LinkContainer to="/settings/roles">
            <NavItem>
              <FormattedMessage id="studio.settings-navigation.link-roles" defaultMessage="Roles"/>
            </NavItem>
          </LinkContainer>);
    }

    return configurationElements;
  }

  private renderConfigurationElements = () => {
    const {active} = this.state;
    const configurationElements: JSX.Element[] = [];

    if (this.state.configurationDescription) {
      this.state.configurationDescription.configurationSets.forEach(config => {
        if (!config.id.startsWith("_")) {
          const element = <LinkContainer id={config.id}
                                         className={active === config.id ? 'active' : ""}
                                         key={`link_${config.id}`}
                                         to={`/settings/config?page=${config.id}`}>
            <NavItem key={`navItem_${config.id}`}>
              {/* tslint:disable */}
              {/* Disabled because: Variables are not allowed for translation messages */}
              <FormattedMessage id={`studio.settings-navigation.${config.id.replace(/%20/g, '')}`}
                                defaultMessage={`${config.name}`}/>
              {/* tslint:enable */}
            </NavItem>
          </LinkContainer>
          configurationElements.push(element);
        }
      });
    }
    return configurationElements;
  }

  private renderLoading = () => {
    return (
        <Row style={{textAlign: "center"}}>
          <h2>
            <FormattedMessage id="studio.settings.general.loading"
                              defaultMessage="Loading..."/>
          </h2>
          <Spinner bigStyle/>
        </Row>
    );
  }

  private setActive = (event: any) => {
    let active = "";
    if (typeof (event.target.baseURI) !== 'undefined') {
      active = this.getActiveTab(event.target.baseURI);
    } else if (typeof (event.target.href) !== 'undefined') {
      active = this.getActiveTab(event.target.href);
    }

    this.setState({active});
  }

  private getActiveTab = (url: string): string => {
    const index = url.lastIndexOf("config?page=");
    return (index > 0 ? url.substring(index + 12) : "");
  }

}